import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-mist-50 px-4 py-16 md:px-8 md:py-24" data-id="element-302" data-mp="3mgahwr509ut0">
      <div className="mx-auto max-w-5xl" data-id="element-303" data-mp="3mez9ge0m7yvk">
        <div className="mx-auto max-w-2xl text-center" data-id="element-304" data-mp="3r7sjnheurzf1">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-305" data-mp="3r9bzx80ieagt">What dental professionals are saying</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-306" data-mp="429tsk29zdmm">
            Clinicians who stopped rebuilding their assessments from scratch
          </h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-307" data-mp="dzxsfl3055a2">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-mist-200 md:p-7" data-id="element-308" data-mp="2auamllx6dm8o">
              <div className="flex gap-0.5 text-cta-500" aria-label="5 out of 5 stars" data-id="element-309" data-mp="2ft584vmj1owh">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-310" data-mp="1nu2pwpu2t9xj" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-ink-800" data-id="element-311" data-mp="1ity4cleb9p0g">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-mist-100 pt-5" data-id="element-312" data-mp="1eufldv61vo09">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-200" loading="lazy" data-id="element-313" data-mp="2bi3ujno4w67o" />
                <div data-id="element-314" data-mp="26ihc8ztg7zs0">
                  <p className="flex items-center gap-1.5 text-[17px] font-extrabold text-ink-900" data-id="element-315" data-mp="22i79rx4v7rhw">
                    {t.name}
                    <BadgeCheckIcon className="h-5 w-5 text-brand-600" aria-label="Verified" data-id="element-316" data-mp="1xiuecnzxhc3p" />
                  </p>
                  <p className="text-sm font-medium text-mist-600" data-id="element-317" data-mp="r4v37ehq0us1">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="Join these professionals today" data-id="element-318" data-mp="nmnw6ayfho96" />
      </div>
    </section>;
}